import React, { useEffect } from "react";
import "./admin_confirm_modal.ui.scss";

interface IAdminConfirmModal {
  open: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  // Styles the confirm button red, for a destructive action.
  danger?: boolean;
  // While the request runs the modal cannot be confirmed again or dismissed.
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const TITLE_ID = "admin_confirm_modal_title";

const AdminConfirmModal = (props: IAdminConfirmModal) => {
  const { open, title, message, confirmText, cancelText, danger, loading, onConfirm, onCancel } = props;

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !loading) onCancel();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open, loading, onCancel]);

  if (!open) return null;

  return (
    <div className="admin_confirm_modal_overlay" data-testid="admin_confirm_overlay" onClick={() => !loading && onCancel()}>
      <div
        className="admin_confirm_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={TITLE_ID}
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id={TITLE_ID} className="admin_confirm_modal_title">{title}</h3>
        <p className="admin_confirm_modal_message">{message}</p>
        <div className="admin_confirm_modal_buttons">
          <button type="button" className="admin_confirm_modal_cancel" disabled={loading} onClick={onCancel}>
            {cancelText}
          </button>
          <button
            type="button"
            className={`admin_confirm_modal_confirm${danger ? " admin_confirm_modal_confirm_danger" : ""}`}
            disabled={loading}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminConfirmModal;
